new Vue({
    el: '#app-references',
    data: {
        references: [],
        sortedReferences: [],
        categories: [],
        selectedCategory: 'all',
        loading: true, 
        modalLoading: false, 
        selectedReference: null,
        showModal: false,
        page: 1, 
        totalPages: 1, 
        loadingMore: false,
        errored: false,
        touchStartX: 0, 
        touchEndX: 0,
        contactButton: acfData.contact_button || { url: null, title: 'Contact' },
        calculatorButton: acfData.calculator_button || { url: null, title: 'Calculator' },
        loadMoreButtonText: acfData.load_more_button_text || null,
        project_description_title: acfData.project_description_title || null, 
        project_in_numbers_title: acfData.project_in_numbers_title || null, 
        industry_commerce_title: acfData.industry_commerce_title || null, 
        client_title: acfData.client_title || null, 
        location_title: acfData.location_title || null, 
        loadingText: acfData.loading_text || null, 
        all_cat_text: acfData.all_cat_text || null,
        power_text: acfData.power_text || null,
        own_powerplant_text: acfData.own_powerplant_text || null,
        own_powerplan_filter_text: acfData.own_powerplan_filter_text || null, 
        ownPowerplant: false,
    },
    mounted() {
        this.fetchCategories();
        this.fetchReferences();
        this.checkHashForReference();
        window.addEventListener('hashchange', this.handleHashChange);
    },
    beforeDestroy() {
        window.removeEventListener('hashchange', this.handleHashChange);
    },
    methods: {
        getApiBaseUrl() {
            const baseUrl = window.location.origin + window.location.pathname.split('/').slice(0, 2).join('/');
            return baseUrl;
        },
        fetchCategories() {
            const baseUrl = this.getApiBaseUrl();
            axios.get(`${baseUrl}/wp-json/wp/v2/reference_category`)
                .then(response => {
                    this.categories = response.data;
                })
                .catch(error => {
                    console.error('Error fetching categories:', error);
                });
        },
        fetchReferences(loadMore = false) {
          if (!loadMore) {
              this.loading = true;
              this.page = 1; 
              this.references = [];
          } else {
              this.loadingMore = true;
          }
      
          const baseUrl = this.getApiBaseUrl();
          let url = `${baseUrl}/wp-json/spikelands/v1/references?per_page=10&page=${this.page}`;
          if (this.selectedCategory !== 'all') {
              url += `&reference_category=${this.selectedCategory}`;
          }
          if (this.ownPowerplant) {
              url += '&own_powerplant=true';
          }
      
          axios.get(url)
              .then(response => {
                  console.log("Fetched references:", response.data);
                  this.references = this.references.concat(response.data);
                  this.totalPages = parseInt(response.headers['x-wp-totalpages']);
                  this.loading = false;
                  this.loadingMore = false;
              })
              .catch(error => {
                  console.error('Error fetching references:', error);
                  this.loading = false;
                  this.loadingMore = false;
                  this.errored = true;
              })
              .finally(() => {
                  this.sortedReferences = this.references;
                  console.log("Sorted references:", this.sortedReferences);
              });
      },
        loadMoreReferences() {
            if (this.page < this.totalPages) {
                this.page++;
                this.fetchReferences(true);
            }
        },
        openModal(referenceId) {
          this.modalLoading = true;
          const baseUrl = this.getApiBaseUrl();
          axios.get(`${baseUrl}/wp-json/wp/v2/reference/${referenceId}`)
              .then(response => {
                  this.selectedReference = response.data;
                  this.showModal = true;
                  this.modalLoading = false;
                  window.location.hash = `#reference-${referenceId}`;
                  this.setupTouchEvents();
              })
              .catch(error => {
                  console.error('Error fetching reference data:', error);
                  this.modalLoading = false;
              });
      },
        closeModal() {
            this.showModal = false;
            this.selectedReference = null;
            window.location.hash = '';
        },
        changeCategory(categoryId) {
            this.selectedCategory = categoryId;
            this.page = 1;
            this.fetchReferences();
        },
        checkHashForReference() {
            const hash = window.location.hash;
            if (hash.startsWith('#reference-')) {
                const referenceId = hash.replace('#reference-', '');
                this.openModal(referenceId);
            }
        },
        handleHashChange() {
            const hash = window.location.hash;
            if (hash.startsWith('#reference-')) {
                const referenceId = hash.replace('#reference-', '');
                this.openModal(referenceId);
            } else {
                this.closeModal();
            }
        },
        prevReference() {
            if (!this.selectedReference || !this.selectedReference.id) {
                console.log('No selected reference to navigate to previous.');
                return;
            }

            const currentIndex = this.sortedReferences.findIndex(ref => Number(ref.ID) === Number(this.selectedReference.id));
            console.log('Prev Reference Index:', currentIndex);

            if (currentIndex > 0) {
                const prevReference = this.sortedReferences[currentIndex - 1];
                if (prevReference && prevReference.ID) {
                    this.openModal(prevReference.ID);
                } else {
                    console.error('Previous reference is invalid:', prevReference);
                }
            } else {
                console.log('Already at the first reference.');
            }
        },
        nextReference() {
            if (!this.selectedReference || !this.selectedReference.id) {
                console.log('No selected reference to navigate to next.');
                return;
            }

            const currentIndex = this.sortedReferences.findIndex(ref => Number(ref.ID) === Number(this.selectedReference.id));
            console.log('Next Reference Index:', currentIndex);

            if (currentIndex < this.sortedReferences.length - 1 && currentIndex !== -1) {
                const nextReference = this.sortedReferences[currentIndex + 1];
                if (nextReference && nextReference.ID) {
                    this.openModal(nextReference.ID);
                } else {
                    console.error('Next reference is invalid:', nextReference);
                }
            } else {
                console.log('Already at the last reference.');
            }
        },
        setupTouchEvents() {
            const modalElement = document.querySelector('.modal-content');
            if (modalElement) {
                modalElement.addEventListener('touchstart', this.handleTouchStart);
                modalElement.addEventListener('touchmove', this.handleTouchMove);
                modalElement.addEventListener('touchend', this.handleTouchEnd);
            } else {
                console.error('Modal content element not found');
            }
        },
        handleTouchStart(event) {
            this.touchStartX = event.changedTouches[0].screenX;
        },
        handleTouchMove(event) {
            this.touchEndX = event.changedTouches[0].screenX; 
        },
        handleTouchEnd() {
            if (this.touchStartX - this.touchEndX > 50) {
                this.nextReference();
            } else if (this.touchEndX - this.touchStartX > 50) {
                this.prevReference();
            }
            this.touchStartX = 0;
            this.touchEndX = 0;
        },
        decodeHtml(html) {
            const txt = document.createElement("textarea");
            txt.innerHTML = html;
            return txt.value;
        },
        toggleOwnPowerplantFilter() {
          this.ownPowerplant = !this.ownPowerplant;
          this.fetchReferences();
      },
    },
    template: `
    <div>
        <div class="portfoliosec_loading" v-if="loading">{{ loadingText || 'Loading...' }}</div>
      
        <div v-if="!loading">
            <div data-duration-in="300" data-duration-out="100" data-current="Alle" data-easing="ease" class="w-tabs">
                <div class="portfoliosec">
                  
                    <div class="tabs-menu w-tab-menu" role="tablist">
                        <a 
                            v-bind:class="['linko', 'w-inline-block', 'w-tab-link', { 'w--current': selectedCategory === 'all' }]" 
                            @click.prevent="changeCategory('all')"
                            role="tab"
                            href="#all"
                            aria-selected="selectedCategory === 'all'"
                        >
                            <div class="tt referenzen">{{ all_cat_text || 'All' }}</div>
                        </a>

                        <a 
                            v-for="category in categories" 
                            :key="category.id"
                            v-bind:class="['linko', 'w-inline-block', 'w-tab-link', { 'w--current': selectedCategory === category.id }]" 
                            @click.prevent="changeCategory(category.id)"
                            :data-w-tab="category.name"
                            role="tab"
                            :href="'#category-' + category.id"
                            aria-selected="selectedCategory === category.id"
                        >
                            <img loading="lazy" :src="category.acf.icon" alt="" class="referenzen-img">
                            <div class="tt referenzen" v-html="category.name"></div>
                        </a>
                    </div>
                    <button class="powerplant-toggle" :class="{ active: ownPowerplant }" @click="toggleOwnPowerplantFilter"><span class="slider"></span></button><span class="toggle-text">{{ own_powerplan_filter_text || 'Filter Own Powerplants' }}</span>

                    <div class="reference-list">
                        <div v-for="reference in sortedReferences" :key="reference.ID" class="reference-item" @click="openModal(reference.ID)">
                            <div class="reference-img-container">
                            <div v-if="reference.own_powerplant" class="ssc-ref-logo"></div>
                                <img v-if="reference.acf && reference.acf.image && reference.acf.image.sizes" 
                                    :src="reference.acf.image.sizes.large" 
                                    :alt="reference.post_title" />
                                <div class="reference-info-overlay">
                                    <div class="reference-info">
                                        <h3 v-if="reference.categories && reference.categories.length">{{ decodeHtml(reference.categories[0]) }}</h3>
                                        <p v-if="reference.acf && reference.acf.power">{{ reference.acf.power }} kWp</p>
                                        <p v-if="reference.acf && reference.acf.location">{{ reference.acf.location }}</p>
                                        <p v-if="reference.acf && reference.acf.client_name"><strong>{{ client_title || 'Client' }}:</strong> {{ reference.acf.client_name }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="page < totalPages" class="load-more-container">
                        <button @click="loadMoreReferences" :disabled="loadingMore" class="load-more-button">
                            {{ loadingMore ? (loadingText || 'Loading...') : (loadMoreButtonText || 'Load More') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="showModal" class="modal-overlay reference-modal" @click.self="closeModal">
            <div class="modal-content">
                <button @click="closeModal" class="modal-close">&times;</button>
                <div v-if="modalLoading">{{ loadingText || 'Loading...' }}</div>
                <div v-if="!modalLoading && selectedReference" class="reference-details">
                    <div class="reference-top-section">
                    <div v-if="selectedReference.own_powerplant" class="ssc-ref-logo"></div>
                        <img 
                            v-if="selectedReference.acf && selectedReference.acf.image && selectedReference.acf.image.sizes" 
                            :src="selectedReference.acf.image.sizes.large" 
                            :alt="selectedReference.post_title" 
                            class="reference-image"
                        />
                    </div>
                    <div class="reference-bottom-section">
                        <div class="left-column">
                            <div class="reference-category-wrapper">
                                <h3 class="reference-category" v-if="selectedReference.categories && selectedReference.categories.length">{{ decodeHtml(selectedReference.categories[0]) }}</h3>
                                <p class="reference-client"><strong>{{ client_title || 'Client' }}:</strong> {{ selectedReference.acf.client_name }}</p>
                                <p class="reference-location"><strong>{{ location_title || 'Location' }}:</strong> {{ selectedReference.acf.location }}</p>

                            </div>
                            <div class="project-in-zahlen-wrapper">
                                <h3 class="project-in-zahlen-title">{{ project_in_numbers_title || 'Project in Numbers' }}</h3>
                                <p class="reference-power">{{ selectedReference.acf.power }} <strong>kWp</strong></p>

                                <div class="modal-buttons">
                                    <a v-if="contactButton.url" :href="contactButton.url" class="btn contact-btn">
                                        {{ contactButton.title || 'Contact' }}
                                    </a>

                                    <a v-if="calculatorButton.url" :href="calculatorButton.url" class="btn calculator-btn">
                                        {{ calculatorButton.title || 'Calculator' }}
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="right-column">
                            <div class="project-description">
                                <h4>{{ project_description_title || 'Project Description' }}</h4>
                                <p v-if="selectedReference.acf && selectedReference.acf.description" v-html="selectedReference.acf.description"></p>

                                
                            </div>
                        </div>
                    </div>

                    <!-- Next and Prev buttons -->
                    <div class="modal-navigation">
                        <button 
                            id="prevReference" 
                            @click="prevReference" 
                            :disabled="sortedReferences.findIndex(ref => Number(ref.ID) === Number(selectedReference.id)) === 0"
                        ></button>
                        <button 
                            id="nextReference" 
                            @click="nextReference" 
                            :disabled="sortedReferences.findIndex(ref => Number(ref.ID) === Number(selectedReference.id)) === sortedReferences.length - 1"
                        ></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    `
});
